import { useContext } from "react"
import { ItemsContext } from "../Items/ItemsRoot"
import { useVisitsQuery } from "../../domain/jobs/jobsQueries"
import { sum } from "../../helpers/array"
import { Visit } from "../../domain/jobs/jobs"
import { centsToDollarsDisplay } from "../displayFormatters"
import StatisticCards from "../common/StatisticCards"

const VisitsPriceSummary = () => {
  const { visitSummary, jobData: { jobId } } = useContext(ItemsContext)
  const getVisitsQuery = useVisitsQuery(jobId)
  const visits = getVisitsQuery.data ?? []
  const reviewedVisits = visits.filter((visit) => visit.billed === true) ?? []
  const notReviewedVisits = visits.filter((visit) => visit.billed === false) ?? []

  const getVisitActual = (visit: Visit): number => {
    if (!visit) {
      return 0;
    }

    if (visitSummary) {
      const summary = visitSummary.find(x => x.visitId === visit.id)
      if (summary) {
        return summary.totalPrice
      }
    }
    return 0
  }

  const notReviewedTotal = sum(notReviewedVisits, visit => getVisitActual(visit))
  const reviewedTotal = sum(reviewedVisits, visit => getVisitActual(visit))

  return <StatisticCards title="Visit Totals" items={[
    { title: 'Not Reviewed', value: centsToDollarsDisplay(notReviewedTotal) ?? '' },
    { title: 'Already Reviewed', value: centsToDollarsDisplay(reviewedTotal) ?? '' },
    { title: 'Total Work', value: centsToDollarsDisplay(notReviewedTotal + reviewedTotal) ?? '' },
  ]} />
}

export default VisitsPriceSummary